import { useHistory } from "react-router-dom";
import { toast } from "sonner";
import { TableRow, TableRowStatus } from "../../components/tables";
import {
  restartDesignRequest,
  deleteDesignRequestId,
} from "../../services/axios";
import { designAreaLabel } from "../../utils/design-areas";

type PRODUCT_VARIANTS = {
  color_name: string;
  color_hex: string;
};

type DESIGN_REQUEST = {
  id: string;
  pk: string;
  status: string;
  campaign: string;
  design_file_url: string;
  design_file_name: string;
  design_file_id: string;
  product_template_name: string;
  product_template_url: string;
  product_template_brand: string;
  product_template_model: string;
  product_template_sku: string;
  configured: false;
  configured_variants: PRODUCT_VARIANTS[];
  configured_layers: string[];
  configured_design_area: string;
  configured_athletes: string[];
  configured_organizations: string[];
  configured_data_url: string;
  request_priority: 0;
  request_job_url: string;
  created_at: string;
  updated_at: string;
};

export const DesignRow = (design: DESIGN_REQUEST) => {
  const history = useHistory();

  const deleteDesignRequest = (design: string) => {
    return deleteDesignRequestId(design)
      .then(() => {
        toast.success("saved", { duration: 5000 });
      })
      .catch((e) => toast.error(e.message, { duration: 5000 }));
  };

  function goToDesign(id: string) {
    history.push({
      pathname: `/design`,
      search: `?sort=${id}`,
    });
  }

  function restartTasks(design: string) {
    return restartDesignRequest(design)
      .then(() => {
        toast.success(`started!`, { duration: 5000 });
      })
      .catch((e) => toast.error(e.message, { duration: 5000 }));
  }

  return (
    <tr className="p-2 m-2 group">
      <TableRow tooltip={true} value={design.created_at} />
      <TableRowStatus tooltip={true} value={design.status} />
      <TableRow tooltip={true} value={design.design_file_id} />
      <TableRow tooltip={true} value={design.campaign} />
      <TableRow tooltip={true} value={design.design_file_name} />
      <TableRow tooltip={true} value={design.product_template_sku} />
      <TableRow
        tooltip={true}
        value={designAreaLabel(design.configured_design_area)}
      />
      <TableRow tooltip={true} value={design.request_job_url} />
      <td
        className="p-2 border border-deeppurple truncate group-hover:bg-gray-200 cursor-pointer underline"
        onClick={() => goToDesign(design.id)}
      >
        View
      </td>
      <td
        className="p-2 border border-deeppurple truncate group-hover:bg-gray-200 cursor-pointer underline"
        onClick={() => restartTasks(design.id)}
      >
        Restart
      </td>
      <td
        className="p-2 border border-deeppurple truncate group-hover:bg-gray-200 cursor-pointer underline"
        onClick={() => deleteDesignRequest(design.id)}
      >
        Delete
      </td>
    </tr>
  );
};
